import holidayService from '../../../common/service/holidayService';

const GROUP_METADATA_URL = '/listing/packages/groups/metadata';

export const getGroupMetaData = async params => {
  const response = await holidayService.post(GROUP_METADATA_URL, params);

  return response;
};
